// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__vvsk6","checkboxInput--secondary":"Checkbox_checkboxInput--secondary__g8r45","checkboxInputChecked":"Checkbox_checkboxInputChecked__Q4g0N"};